/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"

function Bio() {
  return <div>
    <p>
      Doctor's Bazaar blog featuring announcements, updates and industry insights
    </p>
    </div>
}

export default Bio
